import React, { useState, useEffect, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../../stores/authStore';

export default function DebugPanel() {
  const [open, setOpen] = useState(false);
  const user = useAuthStore((s) => s.user);
  const queryClient = useQueryClient();

  const toggle = useCallback((e) => {
    if (e.ctrlKey && e.shiftKey && e.key === 'D') {
      e.preventDefault();
      setOpen((o) => !o);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', toggle);
    return () => window.removeEventListener('keydown', toggle);
  }, [toggle]);

  if (!import.meta.env.DEV) return null;
  if (!open) return null;

  const cache = queryClient.getQueryCache();
  const queries = cache.getAll().slice(-10);

  const token = localStorage.getItem('accessToken');
  let tokenExpiry = '–';
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      tokenExpiry = payload.exp ? new Date(payload.exp * 1000).toLocaleString('de-DE') : '–';
    } catch { /* ignore */ }
  }

  return (
    <div className="fixed bottom-4 right-4 w-96 max-h-96 bg-gray-900 dark:bg-slate-950 text-gray-100 rounded-lg shadow-2xl z-50 overflow-hidden text-xs">
      <div className="flex items-center justify-between px-3 py-2 bg-gray-800 dark:bg-slate-900">
        <span className="font-bold">Debug Panel</span>
        <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-white">&times;</button>
      </div>
      <div className="overflow-y-auto max-h-80 p-3 space-y-3">
        <div>
          <h4 className="font-semibold text-gray-400 mb-1">Auth</h4>
          <p>User: {user?.name || user?.email || '–'}</p>
          <p>Role: {user?.role || '–'}</p>
          <p>Token-Expiry: {tokenExpiry}</p>
        </div>

        <div>
          <h4 className="font-semibold text-gray-400 mb-1">Query Cache ({queries.length})</h4>
          {queries.map((q, i) => (
            <div key={i} className="flex justify-between py-0.5 border-b border-gray-700 dark:border-slate-800">
              <span className="truncate">{JSON.stringify(q.queryKey)}</span>
              <span className={q.state.status === 'success' ? 'text-green-400' : 'text-red-400'}>
                {q.state.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
